import { Form, Modal } from "react-bootstrap";
import Select from 'react-select';

const ShowInMobilePropertiesModal = ({ show, handleSubmit, handleClose, showInMobile, setShowInMobile, sectionData }) => {
    const isFormComplete = showInMobile.title;
    const handleChange = (e) => {
        if (e?.target?.name === "subtitle") {
            setShowInMobile({ ...showInMobile, [e?.target?.name]: e?.target?.value?.map((x) => x?.value) });
        } else {
            setShowInMobile({ ...showInMobile, [e?.target?.name]: e?.target?.value?.value });
        }
    };

    let allFields = []; let allImgFields = []

    for (let section of sectionData) {
        if (section?.dropped_list) {
            for (let key in section.dropped_list) {
                let areas = section.dropped_list[key];

                if (Array.isArray(areas)) {
                    for (let area of areas) {
                        let label = area?.extra_fields?.field_label?.trim();
                        let value = area?.extra_fields?.field_label?.trim();
                        let sValue = `${section.section_name}.${value.replace(/ /g, '_')}`

                        if (label && value && area?.label === "Image Upload") {
                            allImgFields.push({ label, value: sValue });
                        }
                        if (label && value) {
                            allFields.push({ label, value: sValue });
                        }
                    }
                }
            }
        }

        // 🔹 selected_list (array)
        if (section?.selected_list) {
            for (let selected of section.selected_list) {
                let label = selected?.extra_fields?.field_label?.trim();
                let value = selected?.extra_fields?.field_label?.trim();
                let sValue = `${section.section_name}.${value.replace(/ /g, '_')}`

                if (label && value) {
                    allFields.push({ label, value: sValue });
                }
            }
        }
    }
    // debugger
    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>Show In Mobile Properties</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    {allImgFields?.length > 0 &&
                        <Form.Group className="mb-3">
                            <Form.Label>Leading</Form.Label>
                            <Select
                                className="basic-single"
                                classNamePrefix="select"
                                isClearable={true}
                                isSearchable={true}
                                name="leading"
                                options={allImgFields}
                                onChange={(option) =>
                                    handleChange({ target: { name: "leading", value: option } })
                                }
                            />
                        </Form.Group>
                    }
                    <Form.Group className="mb-3">
                        <Form.Label>Title</Form.Label>
                        <Select
                            className="basic-single"
                            classNamePrefix="select"
                            isClearable={true}
                            isSearchable={true}
                            name="title"
                            options={allFields}
                            onChange={(option) =>
                                handleChange({ target: { name: "title", value: option } })
                            }
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Subtitle</Form.Label>
                        <Select
                            isMulti
                            name="subtitle"
                            options={allFields}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            onChange={(option) =>
                                handleChange({ target: { name: "subtitle", value: option } })
                            }
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-outline-primary" onClick={handleClose}>
                    Cancel
                </button>
                <button
                    className="btn btn-primary"
                    disabled={!isFormComplete}
                    onClick={handleSubmit}
                >Save</button>
            </Modal.Footer>
        </Modal>
    )
}
export default ShowInMobilePropertiesModal;